import {
  Button,
  Sheet,
  SheetContent,
  SheetHeader,
  Typography,
} from "@suraasa/placebo-ui"
import { UserCredentials } from "api/resources/credentials/types"
import ShareSheet from "components/ShareSheet"
import CertificateFrame from "features/LearningModule/assets/certificate-frame.webp"
import CertificateStamp from "features/LearningModule/assets/certificate-stamp.webp"
import { useState } from "react"
import { downloadFile, getPlatformURL } from "utils/helpers"

interface Props {
  open: boolean
  handleClose: () => void
  courseName: string
  data: UserCredentials
}

const GetCourseCertificate = ({
  open,
  handleClose,
  data,
  courseName,
}: Props) => {
  const [shareSheet, setShareSheet] = useState(false)

  const certificateImage = data.highResImage || data.lowResImage

  return (
    <>
      <Sheet open={open} onOpenChange={handleClose}>
        <SheetContent height={90}>
          <SheetHeader></SheetHeader>

          <>
            <div className="absolute left-1/2 top-[45%] z-2 -translate-x-1/2 -translate-y-1/2">
              <Typography
                variant="title1"
                className="mb-1 mt-9 text-center"
                style={{ fontFamily: "Nicholas-Bold" }}
              >
                Congratulations!
              </Typography>
              <Typography
                variant="largeBody"
                className="mb-3 text-center sm:mb-5"
              >
                You have successfully completed {courseName}
              </Typography>
              <div className="relative flex justify-center gap-1">
                <img
                  src={CertificateStamp}
                  alt="certificate-stamp"
                  className="absolute left-[49.1%] top-[41.5%] z-1 hidden max-h-[332.34px] max-w-[332.95px] opacity-10 md:block"
                  width="99.69%"
                  height="99.69%"
                />
                <img
                  src={CertificateFrame}
                  alt="certificate-frame"
                  className="relative z-2 max-h-[334px] min-h-[246.57px] w-[300px] min-w-[184px] max-w-[447px] drop-shadow-[-5px_8px_9px_rgba(0,0,0,0.25)] sm:w-full"
                  height="100%"
                />
                {certificateImage && (
                  <img
                    alt="course certificate"
                    src={certificateImage}
                    className="absolute left-1/2 top-1/2 z-3 aspect-[373.13px/264.66px] max-h-[264.66px] max-w-[373.13px] -translate-x-1/2 -translate-y-1/2"
                    /**
                     * These width and height percentages are calculated from
                     * <CertificateFrame/> min height and width
                     */
                    width="88.176%"
                    height="83.47 %"
                  />
                )}
              </div>
              <div className="absolute z-5 mt-5 flex w-full justify-center gap-1">
                <Button
                  color="black"
                  className="!rounded-full"
                  disabled={!data.pdfFile}
                  onClick={() => {
                    if (data.pdfFile) downloadFile(data.pdfFile, "Certificate")
                  }}
                >
                  Download Certificate
                </Button>

                <Button
                  color="black"
                  className="!rounded-full"
                  onClick={() => {
                    setShareSheet(true)
                  }}
                >
                  Share
                </Button>
              </div>
              <div className="min-h-[100px]"></div>
            </div>
            <svg
              className="absolute bottom-0 z-1"
              width="100%"
              height="410"
              viewBox="0 0 965 410"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="482" cy="964.172" r="964" fill="#F5FAFF" />
            </svg>
          </>
        </SheetContent>
      </Sheet>
      <ShareSheet
        open={shareSheet}
        handleClose={() => setShareSheet(false)}
        data={{
          url: getPlatformURL("suraasa", `/verify/${data?.serialNumber}`),
        }}
      />
    </>
  )
}

export default GetCourseCertificate
